// ============================================================================
// FSA NARRATIVE COMPONENT ENDPOINTS (ADR-0005)
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from '../base.endpoints';
import type { ID } from '../../types';

const BASE_PATH = '/FsaNarratives';

export const fsaNarrativeEndpoints = {
  /** GET /api/v1/FsaNarratives/installed */
  installed: () => buildEndpoint(`${BASE_PATH}/installed`),

  /** GET /api/v1/FsaNarratives/component/{code}?version=N — full body (latest when version omitted) */
  component: (code: string) =>
    buildEndpointWithParams(`${BASE_PATH}/component/:code`, { code }),

  /** GET /api/v1/FsaNarratives/by-engagement/{engId}/status */
  engagementStatus: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/status`, { engId }),

  /** POST /api/v1/FsaNarratives/by-engagement/{engId}/update */
  updatePin: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/update`, { engId }),
} as const;

export default fsaNarrativeEndpoints;
